<template>
  <a-pagination
    show-size-changer
    :show-total="(total) => `共 ${total} 条数据`"
    :current="Number(pageNo)"
    :total="Number(total)"
    :page-size="Number(pageSize)"
    @showSizeChange="pageSizeChange"
    @change="pageChange"
    show-quick-jumper
  />
</template>

<script>
  /**
   * 分页组件
   * <mpm-pagination :current.sync="httpResult.current" :pages.sync="httpResult.pages"
   * :size.sync="httpResult.size" :total.sync="httpResult.total"
   * @cb="pageChange"/>
   */
  export default {
    name: 'pagination',
    props: {
      pageNo: {
        default: 1,
      },
      pages: {
        default: 0,
      },
      pageSize: {
        default: 20,
      },
      total: {
        default: 0,
      },
    },
    data() {
      return {}
    },
    created() {},
    methods: {
      pageSizeChange(current, pageSize) {
        this.$emit('update:pageNo', this.pageSize == pageSize ? current : 1)
        this.$emit('update:pageSize', pageSize)
        this.$emit('cb', {
          pageNo: this.pageNo,
          pages: this.pages,
          pageSize: this.pageSize,
          total: this.total,
        })
      },
      pageChange(current, pageSize) {
        this.$emit('update:pageNo', current)
        this.$emit('cb', {
          pageNo: this.pageNo,
          pages: this.pages,
          pageSize: this.pageSize,
          total: this.total,
        })
      },
    },
  }
</script>

<style lang="scss" scoped></style>
